// src/config/siteCredentials.js
//
// The educator credibility tiles (MA / IELTS 9.0 / years teaching / RTHK) --
// the SINGLE SOURCE OF TRUTH shared by the marketing homepage About section
// (HomePage.jsx) and the logged-in dashboard trust strip (DashboardPage.jsx),
// so the two can never drift. DATA ONLY: each surface renders these in its own
// palette (book-* on the homepage, burgundy-* on the dashboard).
export const CREDENTIAL_TILES = [
    { n: 'MA in English Studies', l: 'University of Hong Kong · Distinction' },
    { n: 'IELTS Academic 9.0/9.0', l: 'English language proficiency' },
    { n: '10+ years', l: 'Teaching experience' },
    { n: 'Featured on RTHK', l: 'Hong Kong’s public service broadcaster' },
];
